/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 21.0001H21M3 3.00006H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 9.00006L21 9.00006M11 15.0001L21 15.0001M3 9.00006L6 12.0001L3 15.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3 21.0001H21M11 9.00006L21 9.00006M11 15.0001L21 15.0001M3 3.00006H21M3 9.00006L6 12.0001L3 15.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 21H21M11 9L21 9M11 15L21 15M3 3H21M3 9L6 12L3 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18 21.0001H21M3 21.0001H14M11 9.00006L21 9.00006M11 15.0001H21M18 3.00006H21M3 3.00006H14M3 9.00006L6 12.0001L3 15.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.00024 21.0001H21.0002M11.0002 9.00006L21.0002 9.00006M11.0002 15.0001L21.0002 15.0001M3.00024 3.00006H21.0002M3.00024 9.00006L6.00024 12.0001L3.00024 15.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 21H21M11 9L21 9M11 15L21 15M3 3H21M3 9L6 12L3 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
